import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import { post } from "../../../../../utils/helpers/api";
import { toast } from "react-toastify";

function CreateCallPurposeModal({ isOpen, toggle, refreshSettings, purposeToEdit }) {
  const { t } = useTranslation();
  const [saveLoading, setSaveLoading] = useState(false);
  const [purposeData, setPurposeData] = useState({
    name: purposeToEdit?.name || null,
  });

  useEffect(() => {
    if(purposeToEdit) {
      setPurposeData({
        name: purposeToEdit?.name || null,
      });
    } else {
      setPurposeData({
        name: null,
      });
    }
  }, [purposeToEdit, isOpen]);

  const saveCallPurpose = async () => {
    setSaveLoading(true);
    const url = purposeToEdit ? `/crm/settings/call-purposes/update/${purposeToEdit.id}` : '/crm/settings/call-purposes/store';
    const data = await post(url, purposeData)
    if(data?.success) {
      refreshSettings();
      toggle();
      toast.success(purposeToEdit ? t('alerts.success_update') : t('alerts.success_create'));
    } else {
      toast.error(data?.message || t('alerts.error'));
      toggle();
    }
    setSaveLoading(false);
  }

  return(
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader toggle={toggle}>{purposeToEdit ? t('crm.settings.call_purposes.edit') : t('crm.settings.call_purposes.create_new')}</ModalHeader>

      <ModalBody>
        <FormGroup>
          <Label>{t('common.name')}: </Label>
          <Input 
            value={purposeData?.name}
            onChange={e => setPurposeData({...purposeData, name: e.target.value})}
          />
        </FormGroup>
      </ModalBody>

      <ModalFooter>
        <DefaultButton color="secondary" size="sm" outline onClick={toggle}>{t('common.cancel')}</DefaultButton>
        <DefaultButton 
          color="primary" 
          size="sm" 
          onClick={saveCallPurpose}
          loading={saveLoading}
          disabled={saveLoading || !purposeData?.name}
        >{t('common.save')}</DefaultButton>
      </ModalFooter>
    </Modal>
  );
}

export default CreateCallPurposeModal;